@import '../../../../../constants/spacing.module.less';
@import (reference) '../../../settings-page.module.less';

.carrier-packages-table {
  width: 100%;
  border: @settings-page--table--border;
  color: @settings-page--table--body--cell--text-color;
  background-color: @settings-page--table--body--cell--background-color;
  font-size: @settings-page--table--font-size;
  line-height: @settings-page--table--line-height;
}

.checkbox-column {
  flex-grow: 40px;
  max-width: 40px;
  min-width: 40px;
}

.header-row {
  font-weight: @settings-page--table--header--cell--font-weight;
  color: @settings-page--table--header--cell--text-color;
  background-color: @settings-page--table--header--cell--background-color;
  border-bottom: @settings-page--table--border;
}

.body-row {
  height: 40px;
}
